// extracted by mini-css-extract-plugin
module.exports = {"signUpLinkContainer":"EntryPage_signUpLinkContainer__3kT3B","spinner":"EntryPage_spinner__1FDlh"};